module.exports = __webpack_public_path__ + "img/home3.be8752d7.svg";